import { render } from "./Team4Flags.vue?vue&type=template&id=0b9ecbfb"
import script from "./Team4Flags.vue?vue&type=script&lang=js"
export * from "./Team4Flags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/Team4Flags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b9ecbfb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b9ecbfb', __exports__)) {
    api.reload('0b9ecbfb', __exports__)
  }
  
  module.hot.accept("./Team4Flags.vue?vue&type=template&id=0b9ecbfb", () => {
    api.rerender('0b9ecbfb', render)
  })

}


export default __exports__